export const serviceTerms = {
  title: "QWiK 서비스 이용약관",
  lastUpdated: "2025-11-21",
  effectiveDate: "2025-11-21",

  sections: [
    {
      id: "article1",
      title: "제1조 (목적)",
      content: `본 약관은 QWiK(이하 "회사")가 제공하는 GitHub 레포지토리 배포 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.`,
      isOpen: false,
    },
    {
      id: "article2",
      title: "제2조 (정의)",
      content: `  1. "서비스"란 회사가 제공하는 GitHub 레포지토리 자동 배포 플랫폼을 의미합니다.
  2. "이용자"란 본 약관에 따라 서비스를 이용하는 개인을 의미합니다.
  3. "프로젝트"란 이용자가 배포 요청한 GitHub 레포지토리를 의미합니다.`,
      isOpen: false,
    },
    {
      id: "article3",
      title: "제3조 (서비스 제공)",
      content: `  1. 회사는 GitHub 레포지토리의 자동 배포 서비스를 제공합니다.
  2. 서비스는 연중무휴 24시간 제공을 원칙으로 하되, 시스템 점검 등의 사유로 일시 중단될 수 있습니다.`,
      isOpen: false,
    },
    {
      id: "article4",
      title: "제4조 (이용자의 의무)",
      content: `  1. 이용자는 본인 소유의 GitHub 레포지토리만 배포할 수 있습니다.
  2. 다음 행위는 금지됩니다:
    • 악성 코드, 바이러스가 포함된 코드 배포
    • 타인의 저작권을 침해하는 코드 배포  
    • 불법적이거나 유해한 콘텐츠 배포
    • 서비스 안정성을 해치는 행위`,
      isOpen: false,
    },
    {
      id: "article5",
      title: "제5조 (리소스 제한)",
      content: `  1. 프로젝트당 최대 500MB 메모리와 2GB 트래픽을 제공합니다.
  2. 요금제에 따라 제공되는 리소스는 상이할 수 있습니다.
  3. 30일 이상 미접속 시 자동으로 서비스가 중단됩니다.

  ※ 세부 요금제별 제한사항은 별도 정책에 따릅니다.`,
      isOpen: false,
    },
    {
      id: "article6",
      title: "제6조 (서비스 중단)",
      content: `회사는 다음의 경우 사전 통지 없이 서비스를 중단할 수 있습니다:
  1. 이용자가 본 약관을 위반한 경우
  2. 시스템 보안상 문제가 발생한 경우
  3. 기타 서비스 운영상 필요한 경우`,
      isOpen: false,
    },
    {
      id: "article7",
      title: "제7조 (면책조항)",
      content: `  1. 회사는 이용자가 배포한 코드의 내용에 대해 책임지지 않습니다.
  2. 회사는 서비스 이용으로 발생한 손해에 대해 고의 또는 중과실이 없는 한 책임지지 않습니다.`,
      isOpen: false,
    },
  ],
};

export default serviceTerms;
